<template>
  <div>
    <div>
      <transition name="fade">
        <div v-if="$store.getters.isShowLoginDialog" class="modal">
          <div class="modal-content">
            <div class="text-center login-title">
              <span style="text-transform: uppercase;">
                {{ isLogin ? $t("login") : $t("register") }}
              </span>
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                @click="handleClose"
              >
                <path
                  d="M13 1L1 13"
                  stroke="#6B6B6B"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M1 1L13 13"
                  stroke="#6B6B6B"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <!-- Country code input -->
            </div>
            <div class="form-input">
              <div
                :class="phoneInput ? 'phone-input brg-input ' : 'phone-input'"
              >
                <svg
                  width="47"
                  height="26"
                  viewBox="0 0 47 26"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 25C18.6274 25 24 19.6274 24 13C24 6.37258 18.6274 1 12 1C5.37258 1 0 6.37258 0 13C0 19.6274 5.37258 25 12 25Z"
                    fill="#D80027"
                  />
                  <path
                    d="M12 7.26074L13.2951 11.2465H17.486L14.0954 13.7098L15.3905 17.6955L12 15.2322L8.60957 17.6955L9.90463 13.7098L6.51416 11.2465H10.705L12 7.26074Z"
                    fill="#FFDA44"
                  />
                  <path
                    opacity="0.8"
                    d="M39 11L35 15L31 11"
                    stroke="#999999"
                    stroke-width="1.5"
                  />
                  <rect
                    opacity="0.5"
                    x="46.25"
                    y="0.75"
                    width="0.5"
                    height="24.5"
                    fill="white"
                    stroke="#999999"
                    stroke-width="0.5"
                  />
                </svg>
                <span class="first__phone-country">+84</span>
                <input
                  type="tel"
                  pattern="\d*"
                  class="phone"
                  v-model="phoneInput"
                  :placeholder="$t('phoneNumber2')"
                />
              </div>
              <!-- Widget captcha start -->
              <div
                :class="captcha ? 'widget__capcha brg-input' : 'widget__capcha'"
              >
                <div class="item">
                  <input
                    type="tel"
                    pattern="\d*"
                    v-model="captcha"
                    :placeholder="$t('captcha')"
                  />
                </div>
                <div class="item capcha">
                  <div class="group-random">
                    <div class="main-text">
                      <img ref="captchaImg" :src="imageCaptcha" alt="" />
                    </div>
                    <button type="button" class="random" @click="getCaptcha">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                      >
                        <path
                          d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Login button -->
            <el-button
              @click="handleLogin"
              class="btn-main btn-login"
              :loading="loadingOTP"
            >
              {{ isLogin ? $t("login") : $t("register") }}
            </el-button>
            <p
              @click="handleActionLogin"
              class="text-center mt-10 mb-10 cursor-pointer text-hover fw-600 c-main"
            >
              {{ isLogin ? $t("create_acc") : $t("login") }}
            </p>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { Message } from "element-ui";
import moment from "moment";
import { getOTP, verifyOTP } from "@/views/api/user";
import { isEmpty } from "@/utils/validate";
import { setInfo } from "@/utils/auth";
import { getDetailUser, checkInfoUser } from "@/views/api/wapV2/user";
import { isVietnamesePhoneNumber } from "@/utils/validate";
import {
  getCookie,
  sourceBuyWap,
  setCookie,
  eventSendInfoUserGa
} from "@/utils/wapAuth";
import { list_path_by_source, REVERSED_SOURCE_BANK } from "@/constant/contant";
import { sendEvenGA } from "@/utils/ga";

export default {
  name: "LoginDialog",
  data() {
    return {
      isLoadingSubmit: false,
      loadingOTP: false,
      minutes: "--",
      seconds: "--",
      interval: 0,
      loginForm: {
        phone: "",
        code: ""
      },
      captcha: "",
      loading: false,
      redirect: undefined,
      otherQuery: {},
      imageCaptcha: "",
      isLogin: true,
      keydata: window.location.protocol + "//" + window.location.host,
      timeOut: moment("4000"),
      isTimeOut: false,
      phoneInput: ""
    };
  },
  computed: {
    time: function() {
      return this.timeOut.format("mm:ss");
    }
  },
  watch: {
    time(data) {
      if (data === "00:00") this.isTimeOut = true;
    },
    "$store.getters.isShowLoginDialog"(value) {
      document.documentElement.style.overflow = "hidden";
      if (value) {
        this.isLogin = true;
        this.captcha = "";
        this.loginForm = {
          phone: "",
          code: ""
        };
        this.getCaptcha();
      } else {
        document.documentElement.style.overflow = "auto";
      }
    },
    "$store.getters.otp"(value) {
      // console.log("$store.getters.otp__________________", value);
      if (!isEmpty(value)) {
        this.verifyOTPLogin(value);
      }
    },
    phoneInput(value) {
      const phone = this.convertPhoneNumber(value);
      this.loginForm.phone = phone;
      this.$store.dispatch("setPhoneNumber", phone);
    }
  },
  $route: {
    handler: function(route) {
      const query = route.query;
      if (query) {
        this.redirect = query.redirect;
        this.otherQuery = this.getOtherQuery(query);
      }
    },
    immediate: true
  },
  created() {
    this.getCaptcha();
    setInterval(() => {
      this.timeOut = moment(this.timeOut.subtract(1, "seconds"));
    }, 1000);
  },
  mounted() {
    window.addEventListener("message", event => {
      const obj = event.data;
      if (obj.type === "chatloginParent") {
        const { phone } = obj.option;
        if (phone) {
          this.phoneInput = phone;
        }
        this.$store.dispatch("showLoginDialog");
      }
    });
  },

  methods: {
    handleActionLogin() {
      this.clearData();
      this.isLogin = !this.isLogin;
      this.getCaptcha();
    },
    convertPhoneNumber(phoneNumber) {
      if (phoneNumber.startsWith("+84")) {
        return "0" + phoneNumber.slice(3);
      } else if (phoneNumber.startsWith("84")) {
        return "0" + phoneNumber.slice(2);
      } else if (!phoneNumber.startsWith("0")) {
        phoneNumber = "0" + phoneNumber;
      }
      return phoneNumber;
    },
    async handleLogin() {
      if (!this.phoneInput) {
        this.$message.error("Vui lòng nhập số điện thoại.");
        return;
      }
      if (!isVietnamesePhoneNumber(this.loginForm.phone)) {
        this.$message.error("Số điện thoại không đúng định dạng.");
        return;
      }
      if (!this.isLogin) {
        const uInfo = await checkInfoUser({ phone: this.loginForm.phone });
        if (uInfo && uInfo.data != null) {
          this.$message.warning(this.$t("notiRegistered"));
          return;
        }
      }
      if (!this.captcha) {
        this.$message.error("Vui lòng nhập mã captcha");
        return;
      }
      if (this.isTimeOut) {
        Message({
          message: "Mã đã hết hạn",
          type: "error",
          duration: 5 * 1000
        });
      } else {
        if (this.loadingOTP) return;
        this.loadingOTP = true;
        axios
          .get("https://api-cms-prod.vcallid.com/admin/verify-captcha", {
            params: {
              keydata: this.keydata,
              capstr: this.captcha
            }
          })
          .then(res => {
            if (res.data.error_code !== 0) {
              this.loadingOTP = false;

              Message({
                message: "Mã Captcha không chính xác",
                type: "error",
                duration: 5 * 1000
              });
            } else if (res.data.error_code === 0) {
              this.loadingOTP = true;
              const merchant = getCookie(sourceBuyWap) || null;
              //truyền thêm merchant đối với các nguồn theo link cấp cho đối tác
              if (
                merchant &&
                list_path_by_source.some(i => i.source_id == merchant)
              ) {
                this.loginForm.merchant = merchant;
              }
              getOTP(this.loginForm)
                .then(res => {
                  if (res.error_code === 0) {
                    this.timeOut = moment(res.data.time * 1000);
                    // this.isLogin = true;
                    this.$store.dispatch("hideLoginDialog");
                    this.$store.dispatch("showOtpDialog");
                  } else if (
                    res.error_code === 1 &&
                    res?.error_msg?.includes("Bạn vừa lấy mã xác nhận")
                  ) {
                    this.$message.error(
                      `Bạn vừa lấy mã OTP${
                        res.error_msg.split("Bạn vừa lấy mã xác nhận")[1]
                      }`
                    );
                    this.getCaptcha();
                  } else {
                    this.$message.error(res.error_msg);
                    this.getCaptcha();
                  }
                })
                .finally(() => {
                  this.loadingOTP = false;
                });
            }
          })
          .finally(() => {});
      }
    },
    async verifyOTPLogin(val) {
      this.loading = true;
      this.loginForm.code = val;
      const merchant = getCookie(sourceBuyWap) || null;
      let source = "WAP";
      //truyền thêm merchant đối với các nguồn theo link cấp cho đối tác
      if (merchant && list_path_by_source.some(i => i.source_id == merchant)) {
        this.loginForm.merchant = merchant;
        source = REVERSED_SOURCE_BANK[merchant];
      }
      const res = await verifyOTP(this.loginForm);
      if (res.error_code === 0) {
        let user = {
          ...res.data,
          id_display: res.data.id_display
        };
        console.log("user.token+++++++++++++++++", user.token);
        axios.defaults.headers.common["Authorization"] = `Bearer ${user.token}`;
        const info = await getDetailUser({ uid: user.id_display || user.vga });
        if (info.error_code === 0) {
          user = {
            ...user,
            avatar: info.data.avatar,
            type_member: info.data.type_member,
            point_wallet: info.data.point_wallet
          };
        }
        // console.log("....................login", res.data);

        this.$store.dispatch("connectChat", user.id_display);
        setInfo(user);

        this.$store.dispatch("hideOtpDialog");
        this.$store.dispatch("reRenderComponent");
        window.scrollTo(0, 0);
        setCookie(eventSendInfoUserGa, "1", { expires: 1 / 24 });
        sendEvenGA(`user_source_${source}`, {
          source,
          phone: user.phone,
          uid: user.vga,
          user_vid: user.vga,
          fullname: user.fullname
        });
        if (!this.isLogin) {
          this.$store.dispatch("setShowUpdateInfo", true);
        }
        //window.location.reload();
      } else {
        this.$message.error("Mã OTP không chính xác");
      }
      this.loading = false;
    },
    getOtherQuery(query) {
      return Object.keys(query).reduce((acc, cur) => {
        if (cur !== "redirect") {
          acc[cur] = query[cur];
        }
        return acc;
      }, {});
    },
    getCaptcha() {
      this.keydata = Math.floor(Math.random() * 100000);
      axios
        .get("https://api-cms-prod.vcallid.com/admin/get-captcha", {
          params: { keydata: this.keydata },
          responseType: "blob"
        })
        .then(res => {
          const urlCreator = window.URL || window.webkitURL;
          this.timeOut = moment(2 * 60 * 1000);
          this.isTimeOut = false;
          this.imageCaptcha = urlCreator.createObjectURL(res.data);
        });
    },
    handleClose() {
      this.$store.dispatch("hideLoginDialog");
      this.clearData();
      this.isLogin = true;
    },
    clearData() {
      this.loginForm = {
        phone: "",
        code: ""
      };
      this.phoneInput = "";
      this.captcha = "";
    }
  }
};
</script>

<style scoped>
.text-center {
  text-align: center;
}

.modal {
  /* Add your modal styles here */
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
}

.modal-content {
  width: 90%;
  background-color: #ffffff;
  padding: 15px;
  border-radius: 10px;
  padding-bottom: 0;
}

.login-title {
  margin-bottom: 15px;
  padding-bottom: 15px;
  position: relative;
  font-size: 18px;
  font-weight: 700;
  color: #000000;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 38px;
  border-bottom: 1px solid #e9e9e9;
}

.login-title svg {
  position: absolute;
  right: 10px;
}

.form-input {
  margin-top: 20px;
}
.form-input .widget__capcha input,
.form-input .phone-input {
  background: rgba(242, 242, 242, 1);
}

.form-input .phone-input {
  border: 1px solid #e9e9e9;
  display: flex;
  align-items: center;
  border-radius: 5px;
  padding: 10px;
}

.first__phone-country {
  display: inline-block;
  margin: 0 10px;
}

.phone-input input[type="text"] {
  padding-left: 10px;
}
.phone-input input {
  width: 100%;
}

.widget__capcha {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  margin: 15px 0;
}

.widget__capcha .item {
  flex: 0 0 calc(50% - 8px);
  width: calc(50% - 8px);
}

.widget__capcha .item input {
  width: 100%;
  padding: 13.5px 15px 13.5px 15px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 400;
  line-height: 16.71px;
  letter-spacing: -0.006em;
  border: unset;
  margin-top: unset;
}

.widget__capcha .item input:focus {
  border: unset;
  outline: none;
}

.widget__capcha .item .group-random {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
}

.widget__capcha .item .group-random button {
  position: absolute;
  right: 0;
  top: 0;
  width: 40px;
  height: 44px;
  border-radius: 0 8px 8px 0;
  outline: none;
  border: none;
  color: #fff;
  background-color: rgba(0, 149, 218, 1);
  display: grid;
  place-items: center;
}

.widget__capcha .item .group-random button svg {
  fill: #fff;
  max-width: 20px;
}

.widget__capcha .item .group-random .main-text {
  border: 1px solid rgba(0, 149, 218, 1);
  width: 100%;
  height: 44px;
  border-radius: 8px;
  display: flex;
  justify-content: start !important;
  align-items: center;
  padding-left: 15px;
  font-size: 22px;
  font-weight: bold;
  color: rgba(0, 149, 218, 1);
}

.widget__capcha .item .group-random .main-text img {
  mix-blend-mode: exclusion;
}

.btn-main,
.btn-main-outline {
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 12px;
  color: #fff;
  background: rgba(28, 58, 169, 1);
  border-radius: 8px;
  border: unset;
  outline: unset;
  font-size: 12px;
  font-weight: bold;
}
.btn-main:hover {
  background: rgba(28, 58, 169, 1);
  color: #fff;
}
.btn-main:focus {
  background: rgba(28, 58, 169, 1);
  color: #fff;
}
.btn-main:active {
  background: rgba(28, 58, 169, 1);
  color: #fff;
}
.btn-main:disabled,
.modal {
  z-index: 2000;
}

.modal .modal-content {
  max-width: 500px;
}

@media screen and (max-width: 354px) {
  .main-text img {
    width: 55px;
  }
}
.phone-input.brg-input {
  background-color: #ffffff;
  border: 1px solid #17479e;
}

.btn-register {
  font-size: 14px;
  font-weight: 700;
}
.btn-login {
  font-size: 16px;
  font-weight: 600;
}
</style>
